import Message from 'interview/services/message'
import { httpError } from 'actions/http'
import { actions } from 'react-redux-form'
import { updateVideoResponse, deleteVideoResponse } from 'actions/video-response'
import { receiveJobOpening } from 'interview/actions/job-opening'
import { languages } from 'i18n'
import { setLanguage } from 'actions'

export const fetchMessages = params => dispatch => Message.get(params.context, params.token)
  .then(({ questions, responses = [], jobOpening }) => {
    // Webcam use parameter has to detect if video exists
    responses.map((response) => {
      response.has = !!response.videoUrl
    })

    if (jobOpening.language in languages) {
      dispatch(setLanguage(jobOpening.language))
    } else {
      // Fallback to english
      dispatch(setLanguage('en'))
    }

    dispatch(actions.change('messages', { questions, videoResponses: responses }))
    // Note: this jobOpening might be also a jobAd, but all we need is same parameters from both
    dispatch(receiveJobOpening(jobOpening))
  })
  .catch((err) => {
    if (err.response && err.response.status === 404) {
      dispatch(httpError(err.response.status))
    } else {
      throw err
    }
  })

export const saveDraft = payload => (dispatch) => {
  if (payload.isMobile) {
    return Message.putMobileVideoResponse(
      payload.context,
      payload.uuid,
      {
        ...payload.response,
      },
    )
      .then((videoResponse) => {
        dispatch(updateVideoResponse('messages', videoResponse, videoResponse))
      })
  }
  return Message.putVideoResponse(
    payload.context,
    payload.uuid,
    {
      ...payload.response,
    },
  )
    .then((videoResponse) => {
      dispatch(updateVideoResponse('messages', videoResponse, videoResponse))
    })
}

export const removeDraft = payload => dispatch => Message.deleteVideoResponse(
  payload.context,
  payload.uuid,
  {
    ...payload.response,
  },
)
  .then((videoResponse) => {
    dispatch(deleteVideoResponse('messages', videoResponse, videoResponse))
  })

export const completeVideo = payload => dispatch => Message.putVideoResponse(
  payload.context,
  payload.uuid,
  {
    ...payload.response,
    saved: true,
  },
)
  .then((videoResponse) => {
    dispatch(updateVideoResponse('messages', videoResponse, videoResponse))
  })
